import { focusWithoutScroll } from '../../common/focus-without-scroll/focus-without-scroll.js';
function navigateSelect(root, event) {
    const select = event.target.closest('[data-navigate-select]');
    if (select?.value) {
        const request = new CustomEvent('zirbelino:catalog-navigate', {
            bubbles: true,
            cancelable: true,
            detail: { source: 'select', url: select.value },
        });
        if (root.dispatchEvent(request)) window.location.assign(select.value);
    }
}

export function initCatalogPage(root) {
    const filter = root.querySelector('[data-catalog-filters]');
    const filterToggle = root.querySelector('[data-catalog-filter-toggle]');
    if (filter && filterToggle) {
        root.classList.add('is-catalog-enhanced');
        const compactQuery = window.matchMedia('(max-width: 69.99rem)');
        let returnFocus = filterToggle;
        const updateFilterAccessibility = () => {
            const closed = !root.classList.contains('is-catalog-filter-open');
            if (compactQuery.matches) {
                filter.setAttribute('role', 'dialog');
                filter.setAttribute('aria-modal', 'true');
                if (closed) filter.setAttribute('aria-hidden', 'true');
                else filter.removeAttribute('aria-hidden');
            } else {
                filter.removeAttribute('role');
                filter.removeAttribute('aria-modal');
                filter.removeAttribute('aria-hidden');
            }
        };
        const closeFilter = ({ restoreFocus = false } = {}) => {
            root.classList.remove('is-catalog-filter-open');
            filterToggle.setAttribute('aria-expanded', 'false');
            document.documentElement.classList.remove('has-catalog-filter-open');
            updateFilterAccessibility();
            if (restoreFocus) focusWithoutScroll(returnFocus);
        };
        const openFilter = () => {
            returnFocus = document.activeElement;
            root.classList.add('is-catalog-filter-open');
            filterToggle.setAttribute('aria-expanded', 'true');
            document.documentElement.classList.add('has-catalog-filter-open');
            updateFilterAccessibility();
            filter.querySelector('button, a')?.focus();
        };

        filterToggle.addEventListener('click', () => {
            if (root.classList.contains('is-catalog-filter-open')) {
                closeFilter({ restoreFocus: true });
            } else {
                openFilter();
            }
        });
        root.querySelectorAll('[data-catalog-filter-close]').forEach((button) => {
            button.addEventListener('click', () => closeFilter({ restoreFocus: true }));
        });
        compactQuery.addEventListener('change', () => {
            closeFilter();
            updateFilterAccessibility();
        });
        updateFilterAccessibility();
        root.addEventListener('keydown', (event) => {
            if (!root.classList.contains('is-catalog-filter-open')) return;
            if (event.key === 'Escape') {
                closeFilter({ restoreFocus: true });
                return;
            }
            if (event.key !== 'Tab') return;

            const focusable = [
                ...filter.querySelectorAll(
                    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])',
                ),
            ].filter((element) => element.getClientRects().length);
            const first = focusable[0];
            const last = focusable.at(-1);
            if (!first || !last) return;
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        });

        let swipe = null;
        filter.addEventListener('pointerdown', (event) => {
            if (
                event.pointerType !== 'touch' ||
                !root.classList.contains('is-catalog-filter-open')
            ) {
                return;
            }
            swipe = { id: event.pointerId, x: event.clientX, y: event.clientY };
        });
        filter.addEventListener('pointerup', (event) => {
            if (!swipe || event.pointerId !== swipe.id) return;
            const horizontalDistance = event.clientX - swipe.x;
            const verticalDistance = event.clientY - swipe.y;
            swipe = null;
            if (
                horizontalDistance < -72 &&
                Math.abs(horizontalDistance) > Math.abs(verticalDistance) * 1.25
            ) {
                closeFilter({ restoreFocus: true });
            }
        });
        filter.addEventListener('pointercancel', () => {
            swipe = null;
        });
    }

    root.addEventListener('change', (event) => navigateSelect(root, event));
}
